import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { SitePickerUnselectedSite } from './unselected-site';
const b = bemClassBuilder('v-site-picker-unselected-site-list');
export const SitePickerUnselectedSiteList = observer(props => {
    const { sites, disabled, onSiteClicked } = props;
    return (_jsx("ul", Object.assign({ className: b.block() }, { children: sites.map(site => (_jsx(SitePickerUnselectedSite, { site: site, disabled: disabled, onClick: onSiteClicked }, site.id))) })));
});
SitePickerUnselectedSiteList.displayName = 'SitePickerUnselectedSiteList';
